/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Goodfortitle2Inputs */

const en_goodfortitle2 = /** @type {(inputs: Goodfortitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Good for`)
};

const de_goodfortitle2 = /** @type {(inputs: Goodfortitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gut für`)
};

/**
* | output |
* | --- |
* | "Good for" |
*
* @param {Goodfortitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const goodfortitle2 = /** @type {((inputs?: Goodfortitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Goodfortitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_goodfortitle2(inputs)
	return de_goodfortitle2(inputs)
});
export { goodfortitle2 as "goodForTitle" }